import Select from '@mui/material/Select'

const InlineSelect = ({ children, ...props }) => {
  return (
    <Select
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray !important',
        },
        '& .MuiSelect-select': {
          color: 'rgb(var(--text-over-secondary-background)) !important',
        },
      }}
      MenuProps={{
        sx: {
          '& .MuiPaper-root': {
            backgroundColor: 'rgb(var(--secondary-background)) !important',
            border: '1px solid rgb(var(--brd-primary)) !important',
            color: 'rgb(var(--text-over-secondary-background)) !important',
          },
          '& .MuiMenuItem-root': {
            backgroundColor: 'rgb(var(--secondary-background))',
            color: 'rgb(var(--over-secondary-background)) !important',
            '&:hover': {
              backgroundColor: 'rgb(var(--primary))',
            },
          },
          '& .Mui-selected': {
            backgroundColor: 'rgb(var(--primary)) !important',
          },
          '& .MuiOutlinedInput-input': {
            color: 'white !important',
          },
        },
      }}
      className="h-9 !bg-secondary-background !text-over-primary-background"
      {...props}
    >
      {children}
    </Select>
  )
}

export default InlineSelect
